



































import { TTabsItem } from '@/api/schema';
import VTabsHash from '@/components/VTabsHash.vue';
import { mapGetters, mapState } from 'vuex';

export enum EAiStreamerTabsKeys {
  AI_STREAMERS = 'ai_streamers',
  WEB_AI_STREAMER_PROFILES = 'web_ai_streamer_profiles',
  GAMES_FOR_AI_STREAMER = 'games-for-ai-streamer',
  JOB_MANAGEMENT = 'job-management'
}

export default {
  name: 'CopyStakeAiStreamerTabsView',
  components: {
    VTabsHash,
    CopyStakeAiStreamersTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAiStreamer/AiStreamers/CopyStakeAiStreamersTab.vue'
      ),
    CopyStakeWebAiStreamerProfilesTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAiStreamer/WebAiStreamerProfiles/CopyStakeWebAiStreamerProfilesTab.vue'
      ),
    CopyStakeGamesForAiStreamerTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAiStreamer/GamesForAiStreamer/CopyStakeGamesForAiStreamerTab.vue'
      ),
    CopyStakeJobManagementTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAiStreamer/JobManagement/CopyStakeJobManagementTab.vue'
      )
  },
  data(): any {
    return {
      currentTab: 0
    };
  },
  computed: {
    ...mapState('app', ['isSuperAdmin']),
    ...mapGetters('Onboarding', ['isUndergroundCasinoGamesIntegrationType']),

    tabs(): TTabsItem[] {
      if (!this.isUndergroundCasinoGamesIntegrationType) {
        return [];
      }

      return [
        {
          id: EAiStreamerTabsKeys.AI_STREAMERS,
          text: 'AI Streamers',
          component: 'CopyStakeAiStreamersTab',
          visible: true
        },
        {
          id: EAiStreamerTabsKeys.WEB_AI_STREAMER_PROFILES,
          text: 'Streamer Profiles',
          component: 'CopyStakeWebAiStreamerProfilesTab',
          visible: true
        },
        {
          id: EAiStreamerTabsKeys.GAMES_FOR_AI_STREAMER,
          text: 'Games for AI Streamer',
          component: 'CopyStakeGamesForAiStreamerTab',
          visible: this.isSuperAdmin
        },
        {
          id: EAiStreamerTabsKeys.JOB_MANAGEMENT,
          text: 'Job Management',
          component: 'CopyStakeJobManagementTab',
          visible: true
        }
      ].filter(({ visible }) => visible);
    }
  }
};
